import axios from "axios";
import * as api from "../server/api";

export const GET_APARTMENTS_REQUEST = "AR/GET_APARTMENTS_REQUEST";
export const GET_APARTMENTS_SUCCESS = "AR/GET_APARTMENTS_SUCCESS";
export const GET_APARTMENTS_FAILURE = "AR/GET_APARTMENTS_FAILURE";

export const GET_SINGLE_APARTMENT_REQUEST = "AR/GET_SINGLE_APARTMENT_REQUEST";
export const GET_SINGLE_APARTMENT_SUCCESS = "AR/GET_SINGLE_APARTMENT_SUCCESS";
export const GET_SINGLE_APARTMENT_FAILURE = "AR/GET_SINGLE_APARTMENT_FAILURE";

export const HIDE_NOTIFICATION_REQUEST = "AR/HIDE_NOTIFICATION_REQUEST";
export const HIDE_NOTIFICATION_SUCCESS = "AR/HIDE_NOTIFICATION_SUCCESS";
export const HIDE_NOTIFICATION_FAILURE = "AR/HIDE_NOTIFICATION_FAILURE";

export const SET_EVADED_REQUEST = "AR/SET_EVADED_REQUEST";
export const SET_EVADED_SUCCESS = "AR/SET_EVADED_SUCCESS";
export const SET_EVADED_FAILURE = "AR/SET_EVADED_FAILURE";

export const SET_PRINTED_REQUEST = "AR/SET_PRINTED_REQUEST";
export const SET_PRINTED_SUCCESS = "AR/SET_PRINTED_SUCCESS";
export const SET_PRINTED_FAILURE = "AR/SET_PRINTED_FAILURE";

export const ADD_VERSAMENTO_REQUEST = "AR/ADD_VERSAMENTO_REQUEST";
export const ADD_VERSAMENTO_SUCCESS = "AR/ADD_VERSAMENTO_SUCCESS";
export const ADD_VERSAMENTO_FAILURE = "AR/ADD_VERSAMENTO_FAILURE";

export const ADD_MESSAGGIO_REQUEST = "AR/ADD_MESSAGGIO_REQUEST";
export const ADD_MESSAGGIO_SUCCESS = "AR/ADD_MESSAGGIO_SUCCESS";
export const ADD_MESSAGGIO_FAILURE = "AR/ADD_MESSAGGIO_FAILURE";

export const REMOVE_USER_FROM_APARTMENT_REQUEST = "AR/REMOVE_USER_FROM_APARTMENT_REQUEST";
export const REMOVE_USER_FROM_APARTMENT_SUCCESS = "AR/REMOVE_USER_FROM_APARTMENT_SUCCESS";
export const REMOVE_USER_FROM_APARTMENT_FAILURE = "AR/REMOVE_USER_FROM_APARTMENT_FAILURE";

const initialState = {
  loading: false,
  error: false,
  data: [],
  singleApartment: {
    name: "Apt",
    user: {
      servizi: [],
      messaggi: [],
      versamenti: [],
    },
  },
};

export default function reducersApartments(state = initialState, action) {
  switch (action.type) {
    case GET_APARTMENTS_REQUEST:
      return { ...state, loading: true };
    case GET_APARTMENTS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case GET_APARTMENTS_FAILURE:
      return { ...state, loading: false, error: action.error };

    case GET_SINGLE_APARTMENT_REQUEST:
      return { ...state, loading: true };
    case GET_SINGLE_APARTMENT_SUCCESS:
      return { ...state, loading: false, singleApartment: action.payload };
    case GET_SINGLE_APARTMENT_FAILURE:
      return { ...state, loading: false, error: action.error };

    case HIDE_NOTIFICATION_REQUEST:
      return { ...state, loading: true };
    case HIDE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((ap) => {
          if (ap.name === action.payload) {
            return {
              ...ap,
              notifications: 0,
            };
          }
          return ap;
        }),
      };
    case HIDE_NOTIFICATION_FAILURE:
      return { ...state, loading: false, data: action.error };

    case SET_EVADED_REQUEST:
      return { ...state, loading: true };
    case SET_EVADED_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((ap) => {
          if (ap.name === action.payload.apartmentName) {
            return {
              ...ap,
              user: {
                ...ap.user,
                servizi: ap.user.servizi.map((servizio) => {
                  if (servizio.id === action.payload.idPrenotazione) {
                    return {
                      ...servizio,
                      evaso: action.payload.evaso,
                    };
                  }
                  return servizio;
                }),
              },
            };
          }
          return ap;
        }),
      };
    case SET_EVADED_FAILURE:
      return { ...state, loading: false, data: action.error };

    case SET_PRINTED_REQUEST:
      return { ...state, loading: true };
    case SET_PRINTED_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((ap) => {
          if (ap.name === action.payload.apartmentName) {
            return {
              ...ap,
              user: {
                ...ap.user,
                servizi: ap.user.servizi.map((servizio) => {
                  if (servizio.id === action.payload.idPrenotazione) {
                    return {
                      ...servizio,
                      printed: action.payload.printed,
                    };
                  }
                  return servizio;
                }),
              },
            };
          }
          return ap;
        }),
        singleApartment: {
          ...state.singleApartment,
          user: {
            ...state.singleApartment.user,
            servizi: state.singleApartment.user.servizi.map((servizio) => {
              if (servizio.id === action.payload.idPrenotazione) {
                return {
                  ...servizio,
                  printed: action.payload.printed,
                };
              }
              return servizio;
            }),
          },
        },
      };
    case SET_PRINTED_FAILURE:
      return { ...state, loading: false, data: action.error };

    case ADD_VERSAMENTO_REQUEST:
      return { ...state, loading: true };
    case ADD_VERSAMENTO_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((ap) => {
          if (ap.name === action.payload.apartment) {
            return {
              ...ap,
              user: {
                ...ap.user,
                versamenti: [...ap.user.versamenti, action.payload.versamento],
              },
            };
          }
          return ap;
        }),
      };
    case ADD_VERSAMENTO_FAILURE:
      return { ...state, loading: false, data: action.error };

    case ADD_MESSAGGIO_REQUEST:
      return { ...state, loading: true };
    case ADD_MESSAGGIO_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((ap) => {
          if (ap.name === state.singleApartment.name) {
            return {
              ...ap,
              user: {
                ...ap.user,
                messaggi: [...ap.user.messaggi, action.payload],
              },
            };
          }
          return ap;
        }),
        singleApartment: {
          ...state.singleApartment,
          user: {
            ...state.singleApartment.user,
            messaggi: [...state.singleApartment.user.messaggi, action.payload],
          },
        },
      };
    case ADD_MESSAGGIO_FAILURE:
      return { ...state, loading: false, data: action.error };

    case REMOVE_USER_FROM_APARTMENT_REQUEST:
      return { ...state, loading: true };
    case REMOVE_USER_FROM_APARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((ap) => {
          if (ap.name === state.singleApartment.name) {
            return {
              ...ap,
              user: initialState.singleApartment.user,
            };
          }
          return ap;
        }),
        singleApartment: {
          ...state.singleApartment,
          user: initialState.singleApartment.user,
        },
      };
    case REMOVE_USER_FROM_APARTMENT_FAILURE:
      return { ...state, loading: false, data: action.error };

    default:
      return state;
  }
}

export const getAllApartments = () => {
  return async (dispatch) => {
    dispatch({ type: GET_APARTMENTS_REQUEST });
    try {
      const { url, method, data } = api.getAllApartments();
      const results = await axios({
        url,
        method,
        data,
      });

      // console.log(results);

      if (results.status === 200) {
        const { appartamentos } = results.data.data;
        const apts = appartamentos.map((apt) => {
          const user = apt.user ? formatUser(apt.user) : null;
          return {
            name: `Apt ${apt.identificativo}`,
            id: apt.id,
            user: user || initialState.singleApartment.user,
          };
        });

        // console.log("apts", apts[0]);
        dispatch({
          type: GET_APARTMENTS_SUCCESS,
          payload: apts,
        });
      } else {
        dispatch({
          type: GET_APARTMENTS_FAILURE,
          error: results.status,
        });
      }
    } catch (e) {
      console.log("error", e);
      console.log("error", e.response);
      dispatch({
        type: GET_APARTMENTS_FAILURE,
        error: e,
      });
    }
  };
};

export const getSingleApartment = (aptId) => {
  return async (dispatch, getState) => {
    dispatch({ type: GET_SINGLE_APARTMENT_REQUEST });
    try {
      let apartments = getState().apartments.data;

      if (!apartments || apartments.length === 0) {
        const { url, method, data } = api.getAllApartments();
        const results = await axios({
          url,
          method,
          data,
        });

        if (results.status === 200) {
          const { appartamentos } = results.data.data;
          const apts = appartamentos.map((apt) => {
            const user = apt.user ? formatUser(apt.user) : null;
            return {
              name: `Apt ${apt.identificativo}`,
              id: apt.id,
              user: user || initialState.singleApartment.user,
            };
          });
          apartments = apts;
          dispatch({
            type: GET_APARTMENTS_SUCCESS,
            payload: apts,
          });
        } else {
          apartments = [];
        }
      }

      const apartment = apartments.find((apt) => apt.name.replaceAll(" ", "") === aptId);

      if (apartment) {
        dispatch({
          type: GET_SINGLE_APARTMENT_SUCCESS,
          payload: {
            ...apartment,
            user: apartment.user || initialState.singleApartment.user,
          },
        });
      } else {
        dispatch({
          type: GET_SINGLE_APARTMENT_FAILURE,
          error: "apartment not found",
        });
      }
    } catch (e) {
      console.log("error", e);
      console.log("error", e.response);
      dispatch({
        type: GET_SINGLE_APARTMENT_FAILURE,
        error: e,
      });
    }
  };
};

export const hideNotification = (apartmentName) => {
  return async (dispatch) => {
    dispatch({ type: GET_APARTMENTS_REQUEST });
    // console.log();
    try {
      dispatch({
        type: HIDE_NOTIFICATION_REQUEST,
        payload: apartmentName,
      });
    } catch (e) {
      dispatch({
        type: HIDE_NOTIFICATION_FAILURE,
        error: e,
      });
    }
  };
};

export const setEvaded = (idPrenotazione, evaso) => {
  return async (dispatch, getState) => {
    dispatch({ type: SET_EVADED_REQUEST });
    // console.log("idPrenotazione", idPrenotazione);
    // console.log("evaso", evaso);
    try {
      const apartment = getState().apartments.singleApartment;
      // console.log(apartment);

      const { url, method, data } = api.updateReservations(idPrenotazione, {
        evaso,
      });
      await axios({
        url,
        method,
        data,
      });

      dispatch({
        type: SET_EVADED_SUCCESS,
        payload: {
          apartmentName: apartment.name,
          idPrenotazione,
          evaso,
        },
      });
    } catch (e) {
      console.log("error", e);
      console.log("error", e.response);
      dispatch({
        type: SET_EVADED_FAILURE,
        error: e,
      });
    }
  };
};

export const setPrinted = (idPrenotazione) => {
  return async (dispatch, getState) => {
    dispatch({ type: SET_PRINTED_REQUEST });
    console.log("idPrenotazione", idPrenotazione);
    try {
      const apartment = getState().apartments.singleApartment;

      const { url, method, data } = api.updateReservations(idPrenotazione, {
        printed: true,
      });
      await axios({
        url,
        method,
        data,
      });

      dispatch({
        type: SET_PRINTED_SUCCESS,
        payload: {
          apartmentName: apartment.name,
          idPrenotazione,
          printed: true,
        },
      });
    } catch (e) {
      console.log("error", e);
      console.log("error", e.response);
      dispatch({
        type: SET_PRINTED_FAILURE,
        error: e,
      });
    }
  };
};

export const addVersamento = (date, value) => {
  return async (dispatch, getState) => {
    dispatch({ type: ADD_VERSAMENTO_REQUEST });
    try {
      const apartment = getState().apartments.singleApartment;

      const { url, method, data } = api.addVersamento(
        apartment.user.userId,
        new Date(date).toISOString(),
        value
      );

      await axios({
        url,
        method,
        data,
      });

      const versamento = {
        apartment: apartment.name,
        versamento: {
          createdAt: data,
          movimento: value,
          descrizione: "Versamento",
          tipologia: "Versamento",
        },
      };
      dispatch({
        type: ADD_VERSAMENTO_SUCCESS,
        payload: versamento,
      });
    } catch (e) {
      console.log(e);
      console.log(e.response);
      dispatch({
        type: ADD_VERSAMENTO_FAILURE,
        error: e,
      });
    }
  };
};

export const addMessaggio = (text) => {
  return async (dispatch, getState) => {
    dispatch({ type: ADD_MESSAGGIO_REQUEST });
    try {
      const messaggio = {
        // id: Math.floor(Math.random() * 10000) + 1,
        createdAt: new Date().toISOString(),
        from: "admin",
        text: text,
      };

      const userId = getState().apartments.singleApartment.user.userId;

      const adminId = getState().account.data.user.id;

      const { url, method, data } = api.sendMessage(userId, adminId, text);

      await axios({
        url,
        method,
        data,
      });

      dispatch({
        type: ADD_MESSAGGIO_SUCCESS,
        payload: messaggio,
      });
    } catch (e) {
      dispatch({
        type: ADD_MESSAGGIO_FAILURE,
        error: e,
      });
    }
  };
};

export const removeUserFromApartment = () => {
  return async (dispatch, getState) => {
    dispatch({ type: REMOVE_USER_FROM_APARTMENT_REQUEST });
    try {
      const apartmentId = getState().apartments.singleApartment.id;

      const { url, method, headers, data } = api.removeUserFromApartment(apartmentId);

      const result = await axios({
        url,
        method,
        headers,
        data,
      });

      // console.log("result", result);

      dispatch({
        type: REMOVE_USER_FROM_APARTMENT_SUCCESS,
      });
    } catch (e) {
      dispatch({
        type: REMOVE_USER_FROM_APARTMENT_FAILURE,
        error: e,
      });
    }
  };
};

const formatUser = (user) => {
  const formatted = {
    userId: user.id,
  };
  formatted.servizi = user.prenotaziones.map((pre) => {
    return {
      id: pre.id,
      evaso: pre.evaso,
      printed: pre.printed,
      tipologia: pre.servizio.nome,
      // tipologia: pre.servizio.identificativo,
      prezzo: pre.servizio_prezzo,
      nome: pre.servizio_nome,
      tipologia: pre.servizio_nome,
      numero: pre.numero || 1,
      data:
        Array.isArray(pre.sottoprenotaziones) && pre.sottoprenotaziones.length > 0
          ? pre.sottoprenotaziones.map((sot) => {
              return {
                tipologia: sot.sottoservizio_nome,
                orario: pre.data_prenotazione,
                numero: sot.quantita,
                prezzo: sot.sottoservizio_prezzo,
                durata: sot.sottoservizio_durata,
              };
            })
          : [
              {
                mittente: pre.mittente,
                numero_pacco: pre.numero_consegna,
                data_consegna_prevista: pre.data_consegna_prevista,
                ora_consegna_prevista: pre.ora_consegna_prevista,
                descrizione: pre.descrizione_consegna,
                data_prenotazione: pre.data_prenotazione,
                ripetizione: pre.frequenza_ripetizione,
                giorni: pre.giorno_ripetizione,
                orario: pre.ora_ripetizione,
                durata: pre.servizio_durata,
              },
            ],
      createdAt: pre.created_at,
    };
  });
  const messaggi = [...user.messaggios_sent, ...user.messaggios_to].sort((a, b) =>
    a.created_at < b.created_at ? -1 : 1
  );
  formatted.messaggi = messaggi.map((msg) => {
    return {
      id: msg.id,
      from: msg.to ? "user" : "admin",
      text: msg.testo,
      createdAt: msg.created_at,
    };
  });
  formatted.versamenti = user.versamentos.map((vers) => {
    return {
      id: vers.id,
      movimento: vers.quantita,
      descrizione: "Versamento",
      tipologia: "versamento",
      createdAt: vers.data_esecuzione,
      // createdAt: vers.created_at,
    };
  });

  return formatted;
};
